import { Component, Optional } from '@angular/core';
import { DynamicFormService } from '@ntap/common';
import {
  DataSource,
  Item,
  ItemActionResult,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ServerItemAction,
  ViewWindow
} from '@ntap/core';

import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-action-server-close-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class ActionServerCloseActionComponent extends ServerItemAction /* DefaultActionComponent */ {
  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional() protected dynamicFormService: DynamicFormService,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    @Optional() protected override window: ViewWindow
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
  }

  protected getActionParams(): Observable<any> {
    // empty implementation in the default case
    return of({});
  }

  getFormParams(): any {
    return this.dynamicFormService.getFormValues();
  }

  override doExecuteWithItem(item: Item): Observable<ItemActionResult> {
    return super.doExecuteWithItem(item);
  }

  override updateItem(itemActionResult: ItemActionResult): void {
    if (itemActionResult.item) {
      super.updateItem(itemActionResult);
      this.listViewProvider.refresh();
    }
  }
}
